import {Condition} from "../engine/Condition";
import {merchantVariableModule} from "../../merchant-state/MerchantVariableModule";

/** @property {{key: string, equal: any|undefined}} options */
export class VariableCondition extends Condition {
    constructor(...args) {
        super(...args);

        this.attachListener(merchantVariableModule, this.requestReEval);
    }

    evaluate() {
        return this.options.hasOwnProperty("equal")
            ? (merchantVariableModule.get(this.options.key) === this.options.equal)
            : merchantVariableModule.has(this.options.key);
    }
}
